import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const Appeals = () => {
  return (
    <Container>


    <h2 className="display-6 fw-bold my-4">
    Appeals

    </h2>
    <hr />
   
      <p className="joab-common-para my-2 ">
      If a manuscript is declined for publication and the editor does not suggest resubmission, authors are strongly advised to submit their paper for publication elsewhere. If an author wishes to appeal against the editor’s decision, the appeal must be made in writing. <br/>
      If an editor agrees to reconsider a paper, the other original referee(s) will have the chance to see and comment on the report of the referee who is the subject of the complaint. New referees can often raise new sets of points, which complicates and lengthens the consideration process instead of simplifying it.<br/>
If an author remains unsatisfied, he or she can <b>write to the Editor</b>, citing the manuscript reference number but the paper must not be submitted for publication elsewhere during this time.

      </p>
    
     
   
    

  </Container>
  );
};

export default Appeals;
